// Business Rules: Payment Rules
// These defaults are overridden by admin settings stored in settingsStore

export interface PaymentRuleConfig {
  minThresholdTL: number;          // Minimum order total for EFT-only mode
  eftDiscountPercent: number;      // Discount % when paying via EFT/Bank Transfer
  hideCreditCardAboveThreshold: boolean; // Hide credit card payment above threshold
}

export const DEFAULT_PAYMENT_RULES: PaymentRuleConfig = {
  minThresholdTL: 10000,
  eftDiscountPercent: 12,
  hideCreditCardAboveThreshold: true,
};

export type PaymentMethodType = 'credit_card' | 'eft' | 'bank_transfer' | 'cash_on_delivery';

export interface PaymentMethod {
  type: PaymentMethodType;
  label: string;
  description: string;
  icon: string;
  available: boolean;
}

export function getAvailablePaymentMethods(
  orderTotal: number,
  config: PaymentRuleConfig = DEFAULT_PAYMENT_RULES
): PaymentMethod[] {
  const isAboveThreshold = orderTotal >= config.minThresholdTL;

  const methods: PaymentMethod[] = [
    {
      type: 'credit_card',
      label: 'Kredi Kartı',
      description: 'Visa, Mastercard, Troy',
      icon: '💳',
      available: !(isAboveThreshold && config.hideCreditCardAboveThreshold),
    },
    {
      type: 'eft',
      label: 'Havale / EFT',
      description: `%${config.eftDiscountPercent} indirim`,
      icon: '🏦',
      available: true,
    },
  ];

  return methods.filter((m) => m.available);
}

export function getEftDiscount(
  orderTotal: number,
  selectedMethod: PaymentMethodType,
  config: PaymentRuleConfig = DEFAULT_PAYMENT_RULES
): number {
  if (selectedMethod === 'eft' || selectedMethod === 'bank_transfer') {
    return Math.round(orderTotal * (config.eftDiscountPercent / 100) * 100) / 100;
  }
  return 0;
}

export function isEftRequired(
  orderTotal: number,
  config: PaymentRuleConfig = DEFAULT_PAYMENT_RULES
): boolean {
  return orderTotal >= config.minThresholdTL && config.hideCreditCardAboveThreshold;
}
